import { render, staticRenderFns } from "./Workspace.vue?vue&type=template&id=1b13a7e0"
import script from "./Workspace.vue?vue&type=script&lang=js"
export * from "./Workspace.vue?vue&type=script&lang=js"
import style0 from "./Workspace.vue?vue&type=style&index=0&id=1b13a7e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports